import {
  OrderStatus,
  OrderType,
} from '../../graphql/order/models/get-orders.models';

export const getOrderStatusTranslationByType = (
  orderStatus: OrderStatus,
  orderType: OrderType,
  isDetails = false,
): string => {
  const isDelivery = orderType === OrderType.delivery;

  if (isDetails && (orderStatus === OrderStatus.new || orderStatus === OrderStatus.externalOrderCreated)) {
    return 'order.status.new.modal';
  }

  return isDelivery ? `order.status.delivery.${orderStatus}` : `order.status.${orderStatus}`;
};
